export const projectConstants = {
  CREATE_PROJECT: "CREATE_PROJECT",
  UPDATE_PROJECT: "UPDATE_PROJECT",
  GET_PROJECTS: "GET_PROJECTS",
  GET_PROJECT_BY_ID: "GET_PROJECT_BY_ID",
  DELETE_PROJECT: "DELETE_PROJECT",
  GET_PROJECT_LIST: "GET_PROJECT_LIST",
};
